export const environment = {
  server_url: 'https://cloud.alachisoft.com',
  production: true,
  default_browser_title: 'NCache Cloud Portal',
  default_browser_title_suffix: ' - NCache',
  azureBaseSignInUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
  license_calculator_url: 'https://www.alachisoft.com/pricing/ncache-cloud-pricing.html',
  login_credentials: {
    azure: {
      tenant: '520b2532-94d0-4a7e-a6e3-b85dcd7de2fa',
      clientId: 'fdab7595-01d0-43d0-af55-d8263030e223',
      backendClientId: '9b94fbaf-34ef-420f-9a4e-081e2aeb32b1',
      extraQueryParameter: 'nux=1', // This is optional
      endpoints: {
        'https://cloud.alachisoft.com/api': 'fdab7595-01d0-43d0-af55-d8263030e223',
      },
      redirectUri: 'https://cloud.alachisoft.com/auth/signin/azure',
      redirectUriDeploymentUser: 'https://cloud.alachisoft.com/subscription/nonce/configuration/azure',
      redirectUriAutoDeploymentUser: 'https://cloud.alachisoft.com/subscription/environment/automatic',
      redirectUriDeploymentUserSettings: 'https://cloud.alachisoft.com/account/deployment_user/azure',
      logoutRedirectUri: 'https://cloud.alachisoft.com/',
      responseType: 'code',
      responseMode: 'query',
      scope: 'openid email profile offline_access https://graph.microsoft.com/User.Read',
      // tslint:disable-next-line: max-line-length
      scopeDeploymentUser: 'openid email profile offline_access User.ReadWrite.All RoleManagement.ReadWrite.Directory',
      accountConfirmRedirectUri: 'https://cloud.alachisoft.comsubscribe/azure/account_confirm',
      logoutUrl: 'https://login.microsoftonline.com/'
    },
    aws: {
      clientId: 'amzn1.application-oa2-client.e5118972eb6a47a3b0156b6f3d41d805',
      scope: 'profile',
      redirectUri: 'https://cloud.alachisoft.comauth/signin/aws',
      responseType: 'code',
      accountConfirmRedirectUri: 'https://cloud.alachisoft.comsubscribe/aws/account_confirm'
    }
  },
  api: {
    baseUrl: 'https://cloud.alachisoft.com/api',
    routes: {
      get_user_idle_time: '/user/idle',
      get_user_details: '/user/details',
      get_available_plans: '/subscription/plans',
      select_plan: '/subscription/plan/select',
      login: '/auth/login',
      check_link: '/auth/reset_link/expired',
      forgot_password: '/auth/password/forgot',
      reset_password: '/auth/password/reset',
      set_cloud_password: '/auth/set_cloud_password',
      check_user_email: '/auth/check_user_email',
      check_email_exists: '/auth/email/exists',
      check_secondary_user: '/auth/check_secondary_user',
      has_multiple_subscriptions: '/auth/has_multiple_subscriptions',
      register: '/auth/register_user',
      login_authentication: '/auth',
      register_user: '/auth/register',
      refresh_token: '/auth/token/refresh',
      logOut_client: '/auth/logout',
      fetch_root_user_subscriptions: '/vendor/azure/create/du/subscriptions',
      create_new_deployment_user: '/deployment/user/azure',
      fetch_proposed_principal_username: '/deployment/user/azure/fetch_proposed_user',
      subscription_view_all: '/subscription/view/all',
      save_marketplace_token: '/subscription/saveToken',
      resolve_marketplace_token: '/subscription/resolveToken',
      subscription_create: '/subscription/create/',
      get_subscription_token_details: '/subscription/token',
      get_subscription_regions: '/subscription/regions',
      subscription_view: '/subscription/view',
      get_ip_location: '/subscription/create/ip',
      get_plan_details: '/subscription/create/get_plan_details',
      get_plan_details_from_state: '/subscription/create/get_plan_details_from_state',
      create_with_existing_account: '/subscription/create/existing_account',
      get_free_trial_expiry_date:'/subscription/free_trial/expiry',
      vms: {
        get_all: "/vm/all",
        get_all_sizes: "/vm/size/all",
        get_by_vm_id:"/vm",
        get_count:'/vm/all/count',
        get_Vm_Public_Ip:'/vm/public_ip',
      },
      pricing:{
        confirm_cost:'/environment/vm/cost'
      },
      quotation:{
        quotation_details:'/quotation/subscription',
        nonhosted_quotation_by_id:'/quotation/nonhosted/by_quotationId',
        generate_24x7_quotation: '/quotation/generate/24X7/by_customer',
        quotation_by_quotation_id: '/quotation/by_quotationId',
        quotation_24_7_price:'/quotation/24X7/price',
        quotation_perioid:'/quotation/period_type',
        quotation_cost_24x7:'/quotation/24_7/cost/calculate',
        env_name_max_length:'/quotation/env_name_length',
        generate_nonhosted_quotation_request:'/quotation/generate/nonhosted/sales',
        quotation_existing_name:'/quotation/environments/existing/list',
        quotation_24x7_cost:'/quotation/get/24x7/cost'
      },
      subscription: {
        activate_awaiting_subscriptions: '/subscription/activate_awaiting_subscriptions',
        get_subscription_edition: '/subscription/detail/get_subscription_edition',
        get_ip_location: '/subscription/create/ip',
        resolve_marketplace_token: '/subscription/token/resolve',
        get_plan_details_from_state: '/subscription/state/plan',
        create: '/subscription/create/',
        end_trial: '/subscription/end_trial/',
        extend_trial: '/subscription/free_trial/extend_trial/',
        vm_counter: '/subscription/free_trial/vm/count',
        verify_otp: '/user/otp/verify',
        resend_otp: '/user/otp/resend',
        create_with_existing_account: '/subscription/create/existing_account',
        has_subscription: '/subscription/exists',
        addz_az_Selection_status_for_subscription: '/subscription/az/connection_selection',
        has_Free_Trial_Subscriptions: '/subscription/has_free_trial_subscriptions',
        get_subscription_plan: '/subscription/plan',
        get_subscription: '/subscription/detail/',
        get_subscription_by_uid: '/subscription',
        get_subscription_detail: '/subscription/details',
        get_versions: '/subscription/version/all',
        get_subscriptions_by_vendor: '/subscription/by/vendor',
        activate: '/subscription/detail/activate',
        change_heart_beat: '/subscription/detail/change_heart_beat',
        get_latest_subscription_period: '/subscription/detail/get_latest_subscription_period',
        get_subscription_discount: '/subscription/detail/discount',
        get_subscription_dimension_cost: '/subscription/detail/dimension_cost',
        get_subscription_remaining_time: '/subscription/detail/subscription_remaining_time',
        get_all_subscription_periods: '/subscription/detail/get_all_subscription_period',
        get_existing_dimension_discount: '/subscription/detail/existing_dimension_cost',
        modify_existing_subscription: '/subscription/detail/modify_existing_subscription',
        modify_next_subscription: '/subscription/detail/modify_next_subscription',
        get_future_subscription_period: '/subscription/detail/get_future_subscription_period',
        get_subscription_cost: '/subscription/detail/cost',
        get_transaction_history: '/subscription/detail/get_transaction_history',
        get_minimum_server_licenses: '/subscription/detail/get_minimum_server_licenses',
        get_minimum_client_licenses: '/subscription/detail/get_minimum_client_licenses',
        get_minimum_server_only_licenses: '/subscription/detail/get_minimum_server_only_licenses',
        get_total_licenses_cost: '/subscription/detail/total_licenses_cost',
        is_next_period_recurring_discount_new: '/subscription/detail/is_next_period_recurring_discount_new',
        get_subscription_status: '/subscription/detail/status',
        enable24x7:'/subscription/enable/24x7/payg',
        check_24x7_exists:'/subscription/check/24x7/exists',
        get_mktplace: "/subscription/get-mktplace-id",
        get_mktplace_id: "/subscription/token/resolve-and-get-purchase-term",
        paid: {
          invoice: '/subscription/paid/invoice',
          is_invoice_pending: '/subscription/paid/is_invoice_pending',
          completedInvoice: '/subscription/paid/completed_invoice',
          accept_invoice: '/subscription/paid/accept_invoice',
          getEnvironments: '/subscription/paid/environments',
          getEnvironmentInfo: '/subscription/paid/env_info',
          get_activation_history: '/subscription/paid/act_hist',
          register_self_buy_request: '/subscription/paid/self_buy',
          pending: '/subscription/all/pending',
          pending_invoice: '/subscription/paid/pending_invoice',
          get_licenses_for_version: '/subscription/paid/get_licenses_for_version',
          transaction_history: '/subscription/paid/transaction_history',
          get_version_from_edition: '/subscription/paid/version_from_edition',
          attach: '/subscription/paid/link_license_to_account',
          has_self_buy: '/subscription/paid/has_self_buy'
        },
        vm: {
          start: '/vm/start',
          stop: '/vm/stop',
          restart: '/vm/restart',
          delete: '/vm/delete',
          dll_update_path: '/vm/dll/update/path'
        },
        transaction: {
          get_transactions: '/transaction',
          get_reservation_transactions: '/transaction/reservations',
          get_monthly_usage_transactions: '/transaction/usage/monthly',
        },
        License:{
          get_Activation_details: '/license/get_activation_details',
          get_monthly_usage_data: '/license/get_monthly_usage',
          get_monthly_usage_months: '/license/get_monthly_usage_months',
          create_License: '/license/create_license',
          get_server_actv_link:'/license/get_server_actv_link'
        },
        email: {
          extend_trail_email: '/subscription/sent_extend_trail_email',
          get_license_email: '/subscription/sent_get_license_email',
        }
      },
      environment: {
        add_allowed_ips: '/environment/allowed_ips',
        get_allowed_ips: '/environment/allowed_ips',
        get_default_cidr: '/environment/default_cidr',
        region_disabled_plans: '/environment/regions/plan/disabled',
        get_quotation_deleted_env:'/quotation/deleted/quotation/envs',
        get_all_existing_environments_for_quotation: '/quotation/environments/existing',
        trigger_vm_status:'/environment/vm/status',
        delete_environment : "/environment/delete",
        get_license_plan_data: '/environment/get_license_plan_data',
        get_all_environments:'/environment/all',
        cluster_formation:'/environment/cluster/formation',
        get_environment_detail:'/environment',
        get_all: '/environment/get_all',
        get_environments_by_subscriptionId: '/environment/all_vms',
        get_all_non_hosted_environments: '/environment/non_hosted?subscriptionId={0}&licenseKey={1}',
        get_cloud_plan: '/environment/detail/getCloudPlan',
        get_cloud_subscriptions: '/vendor/azure/subscriptions',
        get_license_usage_by_environment_id: '/environment/license_usage/getById',
        get_resource_groups_from_cloud_subscription: '/vendor/azure/resource_group',
        get_vnets_from_resource_groups: '/vendor/azure/vnets',
        get_subnets_from_vnets: '/vendor/azure/subnets',
        get_vpcs: '/vendor/aws/vpcs',
        get_vpc_attached_internet_gateway: '/vendor/aws/gateway',
        get_subnets_from_aws: '/vendor/aws/subnets',
        get_ncache_versions: '/environment/versions',
        get_ncache_images: '/environment/get_ncache_images',
        get_free_trial_ncache_image: '/subscription/free_trial/image',
        get_free_trial_ncache_image_for_vendor: '/subscription/free_trial/images/vendor',
        get_free_trial_ncache_images_by_image_id: '/subscription/free_trial/image/id',
        get_template_uri:'/vendor/template_uri',
        get_environment_regions:'/environment/regions',
        get_environment_availabilityzone:'/environment/availabilityzones',
        get_server_profles :'/environment/server_profiles',
        get_aws_availability_zone :'/environment/aws/zone/id',
        detail: {
          start_vm_all: '/environment/detail/vm/startall',
          stop_vm_all: '/environment/detail/vm/stopall',
          change_vm_count: '/environment/detail/vms_add',
          delete_vnet_peer: '/environment/detail/delete_vnet_peer'
        },
        create_vm:'/environment/vm/create',
        retry_create_vm:'/environment/vm/retry',
        get_environment_by_id: '/environment/getById',
        getVmPublicIp:'/environment/get_vm_public_ip',
        create_vnet_peer: '/environment/detail/createVNetPeer',
        sync_with_deployment_user: '/environment/sync_with_deployment_user',
        license_plans: '/environment/get_license_plans',
        license_plan: '/environment/get_license_plan',
        getAllVmSizes:'/environment/get_all_vm_sizes',
        postVnetPeeringData :'/environment/configure/vnet_peering',
        postPrivateLinkData :'/environment/configure/private_link',
        create_environment:'/environment/create',
        retry_create_environment:'/environment/retry',
        configure_environment:'/environment/configure',
        delete_vm:'/environment/vm/delete',
        create_peering: '/environment/peering/create',
        types:'/environment/types',
        check_peering_allowed:'/environment/peering/allowed',
        client_cidr_overlap:'/environment/client_cidr/overlap',
        cidr_validate:'/environment/cidr/validate',
        cidr_overlap:'/environment/cidr/overlap',
        pricing:'/quotation/environment/pricing',
        quotation_generate:'/quotation/generate/by_customer',
        quotation_by_id:'/quotation/by_quotationId',
        get_external_links: '/subscription/external/links',
        quotation_update_status:'/quotation/status',
        quotation_vm_env_pricing:'/quotation/environment/vm/pricing',
        private_link: {
          get_vnet_details: '/environment/vnet',
          get_alias_Id: '/environment/aliasId',
          create_endpoint_service: '/environment/private_link_service/create',
          service_created: '/environment/private_link_service/created',
          create_endpoint: '/environment/private_endpoint/create',
        },
        add_trusted_tenant: {
          get_tenants_and_guests_options: '/environment/az/tenants_guests/options',
          add_tenant_and_guest_user: '/environment/az/tenant',
          check_if_guest_user_accepted: '/environment/az/guest/accepted',
          re_invite_guest_user: '/environment/az/resend_invite',
          get_app_registration_authorize_link: '/environment/az/app',
          check_ncache_authorized: '/environment/az/tenant',
          get_tenants_and_guests: '/environment/az/tenants_guests',
          remove_azure_tenant: '/environment/az/tenant/remove',
          remove_azure_guest_user: '/environment/az/guest/remove',
          get_tenant_ids: '/environment/az/tenants',
          get_guest_users: '/environment/az/guest_users',
          get_client_cidr_list: '/environment/client_cidrs'
        },
        vnet_peering: {
          azure: {
            get_guest_authorize_link: '/environment/az/app',
            send_guest_user_invitation: '/environment/az/invite',
            get_assign_network_contributor_role_script: '/environment/az/assign',
            assign_network_contributor_role: '/environment/az/assign',
            get_vnet_peering_script: '/environment/az/peer',
            check_peering_formed: '/environment/az/peer/check',
            create_vnet_peering: '/environment/az/peer/create',
            remove_peering: '/environment/az/peering/remove',
            get_peering_status: '/environment/az/peer/status',
            initialize_vnet_connection: '/environment/vnet/init'
          },
          aws: {
            create_vpc_peering: '/environment/aws/peering',
            create_route_entry: '/environment/aws/route',
            update_security_rules: '/environment/aws/security_group',
            get_peering_status: '/environment/aws/peering/status',
            get_accept_peering_script: '/environment/aws/peering/script',
            get_add_route_script: '/environment/aws/route/script',
            check_peering_accepted: '/environment/aws/peering_active',
            remove_peering: '/environment/aws/peering/remove',
            check_peering_route_active: '/environment/aws/route_active'
          },
          get_peering: '/environment/peering',
          get_platform_user: '/environment/vnet_peering/platform_user',
          assign_coordinator: '/environment/guest_user/coordinator',
          get_vnet_details: '/environment/vnet_peering/vnet',
          create_peering: '/environment/peering/create',
          get_peering_details: '/environment/peering/details',
          check_peering_accepted: '/environment/aws/cross_peering',
        }
      },
      licensing: {
        manual_activation: '/licensing/macm',
        manual_activation_verify_data: '/licensing/mavd',
        manual_deactivation: '/licensing/mdcm'
      },
      activation_key: '/subscription/key',
      deployment_user: {
        get: '/deployment/user',
        create: '/deployment/user',
        delete: '/deployment/user',
        activate: '/subscription/activate_deployment',
        deactivate: '/subscription/deactivate_deployment',
        confirm_programmatic_deployment: '/deployment/user/confirm_programmatic_deployment'
      },
      account_detail: {
        get: '/user',
        update: '/user',
        getUserDetails:'/user/details'
      },
      user: {
        register: '/user',
        register_lead: '/user/register/from/lead',
        is_email_verified: '/user/verified'
      },
      get_notifications: '/notification',
      get_subscription_by_user_id: '',
      get_total_licenses_for_subscription: '/environment/sum/all',
      get_total_licenses_used: '/environment/license_usage/all',
      get_cloud_regions: '/vendor/region/name',
      environment_create: '/environment/create',
      environment_delete: '/environment/delete',
      environment_exists_by_name: '/environment/existsByName',
      get_all_existing_environments: '/environment/getAllExistingEnvironments',
      get_vm_status: '/vm/status/all',
      check_vm_availability: '/vm/size/available',
      get_vm_stats_by_vm_id: '/environment/detail/vm',
      get_recent_heart_beat_time: '/environment/detail/vm_recent_heart_beat_time',
      get_peer_status_by_environment_id: '/environment/detail/get_peer_status',
      refresh_service: '/refresh',
      read_notifications: '/refresh/notification/read',
      dismiss_notifications: '/refresh/notification/dismiss',
      get_vm_prices:'/region/getVmPrices',
      reservation: {
        create: '/subscription/detail/add_reservation',
        get_all_reservations: '/subscription/detail/get_all_reservations'
      }
    },
    testing_routes: {
      test_refresh_token: '/register/1/1'
    }
  },
  constants: {
    token: 'cloudportalkey',
    tokenExpiration: 'expiredAt',
    vendor: 'cloudVendor',
    redirectUrl: 'login',
    defaultNetworkCidr: '20.200.20.0/24',
    support_email: 'support@alachisoft.com',
    sales_email: 'sales@alachisoft.com',
    emailKey:"emailKey"
  },
  subscription_view_refresh_delay: 5000,
  refresh_view_delay: 5000,
  private_link_service_poll_delay: 5000,
  Auth: {
    Azure: '1',
    Aws: '2',
    Key: 'AuthType'
  },
  routes: {
    reset_password: '/auth/reset_password',
    login: '/auth/login',
    environment: '/subscription/dashboard',
    forgot_password: '/auth/forgot_password',
    sign_in: '/auth/signin',
    environment_detail: ':subscriptionId/environment/:environmentId',
    wan_replication: ':subscriptionId/replication',
    peering: 'peering',
    connection_setup_selection: 'az/connection/selection',
    tenant_authorized_success: 'az/authorized/success',
    add_trusted_tenant: 'az/tenant/add',
    peering_wizard: '/subscription/peering',
    environment_details: 'subscription/{0}/environment/create',
    deployment_automatic: '/subscription/environment/automatic',
    deployment_manual: '/subscription/environment/manual',
    new_subscription_environment: '/environment/view/all/subscribed',
    environment_create: '/environment/create',
    subscription: '/subscription/dashboard',
    server_list: '/subscription/servers_list',
    quotation_history: ':subscriptionId/quotation_history',
    supporttwentyfourseven:'/subscription/purchase/twenty/four',
    subscription_nonce_configuration: '/subscription/nonce/configuration',
    account_without_subscription: '/subscription/no_subscription',
    landing_page: '/landingpage',
    under_maintenance:'subscription/maintenance',
    activations: '/subscription/activations',
    quotation: '/buy/quotation',
    configure_environments: '/buy/configure/environments',
    view_invoice: '/subscription/transaction_history/view',
    transaction_history: ':subscriptionId/transaction_history',
    available_plans: '/subscription/available_plans'
  },
  apiVersion: '2024-11-01',
  excludedUrls: ['/auth/email/exists', '/subscription/token/resolve', '/subscription/create/', '/auth', '/auth/password/reset', '/user', '/token/refresh', '/otp/verify',
    'otp/resend', '/user/verified', '/subscription/plan/select', '/subscription/plans'],
  admin: {
    primary_route: 'admin123',
    routes: {
      home: 'home',
      login: 'login',
      customers_parent: 'customers',
      customers_view: '',
      customers_view_filter: 'filter/:filterName/:filterValue',
      customer_view: ':userId/view',
      subscriptions_parent: 'subscriptions',
      subscriptions_view: '',
      subscriptions_view_filter: 'filter/:filterName/:filterValue',
      subscription_edit: 'subscriptions/:subscriptionId',
      deployments_parent: 'deployments',
      deployments_view: '',
      deployments_view_filter: 'filter/:filterName/:filterValue',
      azure_deployments_view: 'azure',
      aws_deployments_view: 'aws',
      plans: 'plans',
      plan_create: 'plans/create',
      plan_edit: 'plans/:planId',
      notifications: 'notifications',
      background_jobs: 'jobs'
    },
    breadcrumbs: {
      home: 'Home',
      login: 'Login',
      customers_parent: 'Customers',
      customers_view: 'View All',
      customers_view_filter: 'View All',
      customer_view: 'View',
      subscriptions_parent: 'Subscriptions',
      subscriptions_view: 'View All',
      subscriptions_view_filter: 'View All',
      subscription_edit: 'Edit',
      deployments_parent: 'Deployments',
      deployments_view: 'View All',
      deployments_view_filter: 'View All',
      azure_deployments_view: 'Azure',
      aws_deployments_view: 'AWS',
      plans: 'Azure Plans',
      plan_create: 'Create',
      plan_edit: 'Edit',
      notifications: 'Notifications',
      background_jobs: 'Background Jobs'
    },
    toast_delay: 5000
  }
};
